import { render, staticRenderFns } from "./OrderBookResultRow.vue?vue&type=template&id=328c3726&scoped=true"
import script from "./OrderBookResultRow.vue?vue&type=script&lang=js"
export * from "./OrderBookResultRow.vue?vue&type=script&lang=js"
import style0 from "./OrderBookResultRow.vue?vue&type=style&index=0&id=328c3726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c3726",
  null
  
)

export default component.exports